module.exports = __webpack_public_path__ + "static/media/design_tab_img.fe9ec243.jpg";